import React from "react";
import Header from "shared/components/header";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="application">
      <Header staticPage={true} />
      <main className="col-md-12 error-template">
        <h1>Oops!</h1>
        <h2>404 Not Found</h2>
        <div className="error-details">Sorry! Requested page not found!</div>
        <div className="error-actions">
          <Link to={"/home"} className="btn btn-warning btn-lg">
            <span className="glyphicon glyphicon-home" /> Take Me Home
          </Link>
        </div>
      </main>
    </div>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/not-found.js